type CalculateProcessEmissionsParams = {
  activityData: number // t of material
  emissionFactor: number // t CO2/t material
  conversionFactor?: number // dimension-less
}

/**
 * Calculates the process emissions from activity data.
 *
 * @param {CalculateProcessEmissionsParams} params - The parameters for the calculation.
 * @param {number} params.activityData - The activity data. t of material
 * @param {number} params.emissionFactor - The emission factor. t CO2/t material
 * @param {number} [params.conversionFactor=1] - The conversion factor. dimension-less
 * @returns {number} The calculated process emissions.
 */
export default function calculateProcessEmissions({
  activityData: ADi,
  emissionFactor: EFi,
  conversionFactor: CFi = 1
}: CalculateProcessEmissionsParams): number {
  return ADi * EFi * CFi
}
